export default function () {
  return [{
    title: 'Artigos',
    to: {
      name: 'magazine',
    },
    htmlBefore: '<i class="material-icons">book</i>',
    htmlAfter: '',
  }, {
    title: 'Perfil',
    htmlBefore: '<i class="material-icons">person</i>',
    to: {
      name: 'profile',
    },
  }];
}
